module.exports = __webpack_public_path__ + "officialStatic/img/p1.cb55bb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/p1.jpg
// module id = yB3b
// module chunks = 0